<template>
   <div class="form-group">
      <label
         for="ip_country"
         :class="['label-overlay', { active: !isNotEmpty(form.country) }]"
         @click="switchLabel($event)"
         >Country</label
      >
      <select
         id="ip_country"
         v-model="form.country"
         v-getAutoCountryName
         :class="[
            'form-control custom-select',
            { 'is-invalid': isValidName.isInvalid },
            { 'is-valid': isValidName.isValid },
         ]"
         name="country"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateCountryData();
            initiatedType();
         "
         @change="validateCountryData()"
      >
         <option v-for="(option, index) in countries" :key="index" :value="option.value">
            {{ option.text }}
         </option>
      </select>
      <div class="invalid-feedback">We want to know what the weather there is like.</div>
      <div class="valid-feedback">Looks good.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';
import $service from '../../../util/service.js';

export default {
   name: 'CountryComponent',
   data() {
      return {
         countries: [],
         isValidName: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            country: '',
         },
         ...(process.browser && { tracker: this.$tracker.userProfile }),
         person,
      };
   },

   mounted() {
      this.getCountries();

      if (this.person.profileData) {
         this.form.country = this.person.profileData.country || '';
      }
   },
   methods: {
      validateCountryData() {
         this.isValidName.isValid = !this.isNotEmpty(this.form.country);
         this.isValidName.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.country);
         this.$emit('CountryChanged', {
            key: this.form.country,
         });
      },

      initiatedType() {
         if (this.form.country !== '') this.tracker.information({ country: this.form.country });
      },

      async getCountries() {
         try {
            const list = await $service.get('/data/countries');
            this.countries = list.data;
         } catch (error) {
            // eslint-disable-next-line
            console.warn('Fetching error');
         }
      },
   },
};
</script>
